module.exports = __webpack_public_path__ + "btn-googleplay.png?5803edf0721828def369a7141f4c339d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-googleplay.png
// module id = 41
// module chunks = 0